enum DiaryResources {
  classes = 'classes',
  practitioner = 'practitioner',
  room = 'room',
  list = 'list',
  waitingList = 'waitingList'
}

export default DiaryResources;
